import script from "./Regulation.vue?vue&type=script&setup=true&lang=js"
export * from "./Regulation.vue?vue&type=script&setup=true&lang=js"

import "./Regulation.vue?vue&type=style&index=0&id=2ecaa51a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ecaa51a"]])

export default __exports__